import {EntityField} from "../../core/genericdocuments/EntityField"
import {EntityFieldDataType} from "../../core/genericdocuments/EntityFieldDataType"
import {EntityFieldsDescriptor} from "../../core/genericdocuments/EntityFieldsDescriptor"
import {LookupEntities} from "../../core/genericdocuments/ReferenceDetails"
import {Position} from "../../models/Position"

export const positionFields: IntercateKeysMap<Position, EntityField<Position>> = {
    id: {
		name: "id", dataType: EntityFieldDataType._string, label: "Id pozicije",
		validator: { required: true },
		sortable: true,
		filterable: true
	},
    title: {
		name: "title", dataType: EntityFieldDataType._string, label: "Ime pozicije",
		validator: { required: true },
		sortable: true,
		filterable: true
	},
    description: {
		name: "description", dataType: EntityFieldDataType._string, label: "Opis pozicije",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    departmentId: {
		name: "departmentId", dataType: EntityFieldDataType._reference, label: "Sektor",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Departments
		},
		validator: { required: true },
		sortable: true
	},
}

const positionFieldsArray: Array<EntityField<Position>> = [
	positionFields.title,
	positionFields.description,
	positionFields.departmentId,
]

export const positionFieldsDescriptor: EntityFieldsDescriptor<Position> = {
	listFields: positionFieldsArray,
	createFormFields: positionFieldsArray,
	updateFormFields: positionFieldsArray
}